import request, { CMS_SITE_ID } from '@/utils/request';

function extractNameFromPath(path) {
  // 正则表达式来匹配"name.json"中的"name"
  const regex = /\/([^/]+)\.json$/;
  const match = path.match(regex);

  if (match && match[1]) {
    return match[1]; // 返回匹配到的"name"
  } else {
    return null; // 如果没有匹配到，则返回null
  }
}

/** 标题信息 */
export const cataloglist = () => request({
  url: '/lxjjh/json/catalog/list.json',
  method: 'get',
});

/** 首页信息 */
export const cmsHomeData = () => request({
  url: '/lxjjh/json/index.json',
  method: 'get',
});

/** 获取栏目信息 */
export const cmsCatalogTreeDataRead = (catalogAlisa) => request({
  url: '/api/cms/catalog/tree-data/read',
  method: 'get',
  params: { catalogAlisa },
});

export const likelist = (catalogId) => request({
  url: '/prod-api/api/stat/like/list',
  method: 'get',
  params: {
    siteId: CMS_SITE_ID,
    catalogId
  },
});

export const apianonissue = () => request({
  url: '/prod-api/api/anon/issue',
  method: 'post',
  params: {
  },
});

export const apistatlike = (catalogId,contentId) => request({
  url: '/prod-api/api/stat/like',
  method: 'post',
  data: {
    siteId: CMS_SITE_ID,
    catalogId,
    contentId
  },
});

/** 内容（文章）详情信息 */
export const cmsCatalogContentData = (catalogAlisa, fileName) => request({
  url: `/lxjjh/json/catalog/${catalogAlisa}/content/${fileName}.json`,
  method: 'get',
});

/** 栏目下的内容（文章）列表
 * @param {Object} params - 参数对象
 * @param {number} params.pageNum - 当前页码
 * @param {number} params.pageSize - 每页显示的数量
 * @param {number} params.catalogAlisa - 所属栏目的别名
*/

export const indexData = () => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/index.json`,
      method: 'get',
    }).then(res => {
      resolve({ 
        data: {
          res
        },
      });
    })
    .catch(err => {
      reject(err);
    });
  });
};


export const xwdtList = () => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/home/xwdt.json`,
      method: 'get',
    }).then(res => {
      resolve({ 
        data: {
          res
        },
      });
    })
    .catch(err => {
      reject(err);
    });
  });
};


export const xwzxList = () => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/home/xwzx.json`,
      method: 'get',
    }).then(res => {
      resolve({ 
        data: {
          res
        },
      });
    })
    .catch(err => {
      reject(err);
    });
  });
};

export const hzhbList = () => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/home/hzhb.json`,
      method: 'get',
    }).then(res => {
      resolve({ 
        data: {
          res
        },
      });
    })
    .catch(err => {
      reject(err);
    });
  });
};


export const cmsCatalogContentAllList = ({ catalogAlisa }) => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/catalog/${catalogAlisa}/content/list.json`,
      method: 'get',
    }).then(res => {
      resolve({ 
        data: {
          contentList: res.contentList.map((v) => ({
            ...v,
          })),
        },
      });
    })
    .catch(err => {
      reject(err);
    });
  });
};

export const contentSummaryList = ({ catalogAlisa }) => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/catalog/${catalogAlisa}/contentSummary.json`,
      method: 'get',
    }).then(res => {
      resolve({ 
        data: {
          contentList: res.contentList.map((v) => ({
            ...v,
          })),
        },
      });
    })
    .catch(err => {
      reject(err);
    });
  });
};

export const cmsCatalogContentList = ({ catalogAlisa, pageNum }) => {
  return new Promise((resolve, reject) => {
    request({
      url: `/lxjjh/json/catalog/${catalogAlisa}/page-info.json`,
      method: 'get',
    }).then(res => {
      const { total, urlList } = res;

      // 查找找对应page的jsonUrl
      const pageJsonUrl = urlList.find((item) => item.index === pageNum)?.url;
      if (total === 0 || !pageJsonUrl) {
        resolve({ data: { contentList: [], total: 0 } });
        return;
      }

      request({
        url: location.hostname === 'localhost' ? `/lxjjh/json/catalog/${catalogAlisa}/content/list${pageNum}.json` : pageJsonUrl,
        method: 'get',
      }).then(res2 => {
        resolve({ 
          data: {
            contentList: res2.cmsContentList.map((v) => ({
              ...v,
              contentId: extractNameFromPath(v.url),
            })),
            total: res.total,
          },
        });
      });
    }).catch(err => {
      reject(err);
    });
  });
};
export const cmsCatalogContent = ({ id, catalogAlisa}) => {
  return new Promise((resolve) => {
  request({
    url: `/lxjjh/json/catalog/${catalogAlisa}/content/${id}.json`,
    method: 'get',
  }).then(res => {
    resolve({ 
      data: res
    });
  });
})
}

/** 文章搜索
 * @param {Object} q - 搜索词
*/
export const cmsCatalogContentSearch = ({ q, catalogId, publishStartDate, publishEndDate }) => request({
  url: '/prod-api/api/cms/catalog/content/search',
  method: 'get',
  params: { q, siteId: CMS_SITE_ID, catalogId, publishStartDate, publishEndDate },
});

/**
 * 文章-增加访问次数
 * @param {Object} data - 参数对象
 * @param {number} data.catalogId - 分类ID
 * @param {number} data.contentId - 文章ID
*/
export const cmsStatContentVisit = (data) => request({
  url: '/prod-api/api/stat/content/visit',
  method: 'post',
  data: { ...data, siteId: CMS_SITE_ID },
});

/**
 * 文章-查询访问次数
 * @param {Object} params - 参数对象
 * @param {number} params.catalogId - 分类ID
 * @param {number} params.contentId - 文章ID
*/
export const cmsStatContentVisitCount = (params) => request({
  url: '/prod-api/api/stat/content/visit/count',
  method: 'get',
  params: { ...params, siteId: CMS_SITE_ID },
});